export const fetchTrees = resp => {
  return {
    type: "FETCH_TREES",
    payload: resp
  };
};

export const saveTree = resp => {
  return {
    type: "SAVE_TREE",
    payload: resp
  };
};

export const setCurrentTreeId = id => {
  return {
    type: "SET_CURRENT_TREE_ID",
    payload: id
  };
};

export const deleteTree = resp => {
  return {
    type: "DELETE_TREE",
    payload: resp
  };
};

export const setFilterNotIn = ids => {
  return {
    type: "SET_FILTER_NOT_IN",
    payload: ids
  };
};

export const setOpenDeleteConfirm = visible => {
  return {
    type: "SET_OPEN_DELETE_CONFIRM",
    payload: visible
  };
};



// WEBPACK FOOTER //
// ./src/actions/actions/tree.js